import fetch from '@/utils/fetch'
import {
    shop_url
} from '@/global'
const tradeGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/condition`,
        method: "post",
        data
    })
}

const getUploadToken = () => {
    return fetch({
        url: `${shop_url}/shop/shop/category/auth`,
        method: "get"
    })
}

const getUploadId = (data, number) => {
    return fetch({
        url: `${shop_url}/shop/shop/category/getId?num=${number}`,
        method: "get"
    })
}
const addGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good`,
        data,
        method: "post"
    })
}
const addPreGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good/v2`,
        data,
        method: "post"
    })
}
const setPreGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good/pre-sell`,
        data,
        method: "post"
    })
}
const putGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/status/${data.goodId}/${data.status}`,
        data,
        method: "put"
    })
}
const getpreSellList = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/condition/v2`,
        data,
        method: "post"
    })
}
const exitGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/goodUp`,
        data,
        method: "put"
    })
}
const addbatch = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/category/batch`,
        data,
        method: "post"
    })
}

const getbatch = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/category/batch/${data.goodId}`,
        method: "get"
    })
}
const getgoodsclassification = data => {
    return fetch({
        url: `${shop_url}/shop/shop/category/${data.shopId}`,
        method: "get"
    })
}
const getgoodInfo = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/info/v2/${data.goodId}`,
        method: "get"
    })
}
// 获取商品分类 /shop/good/goodTypeListC
const getGoodCategory = () => {
    return fetch({
        url: `${shop_url}/shop/shop/good/goodTypeList`,
        method: "get"
    })
}
const upadteGoodStatus = function (goodId, status) {
    return fetch({
        url: `${shop_url}/shop/shop/good/status/${goodId}/${status}`,
        method: "put"
    })
}
// 修改库存
const upadteGoodStock = function (data) {
    return fetch({
        url: `${shop_url}/shop/shop/stock/stock`,
        method: "put",
        data
    })
}
// 获取用户信息
const getUserInfo = () => {
    return fetch({
        url: `${shop_url}/user/users/info`,
        method: 'GET'
    })
}
// 商品批量上下架
const goodsShelve = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/goodBatch`,
        method: 'post',
        data
    })
}
// 导出商品表格
const getGoodsExcel = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/v1/report/${data.mchId}/${data.stime}/${data.etime}`,
        method: 'GET'
    })
}
const exitPreGoods = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good/pre-updatePresellSetting`,
        data,
        method: "put"
    })
}
// 秒杀列表
const getSeckillList = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/activityList/${data.page}/${data.pageCount}/${data.status}/${data.mchId}`,
        methods: 'GET',
    })
}
// 获取秒杀商品列表
const getSeckillGood = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good/getGoodSeckill/${data.page}/${data.pageCount}/${data.mchId}?goodName=${data.goodName}`,
        data,
        method: "GET"
    })
}

// 提交秒杀活动
const setSeckill = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/good/insertGoodSeckill`,
        data,
        method: 'post'
    })
}

const editSeckill = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/updateActivityInfo`,
        data,
        method: 'put'
    })
}

const delSeckill = (id) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/deleteActivityInfo/${id}`,
        method: 'delete'
    })
}
const getSeckillDetails = (activityId) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/selectActivityInfo/${activityId}`,
        method: 'GET'
    })
}
// 导出日报表格
const getDailyExcel = (data) => {
    return fetch({
        url: `${shop_url}/shop/reportDownload?mchId=${data.mchId}&date=${data.date}`,
        method: 'GET'
    })
}

const getVideoList = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/video/mchId/${data.mchId}/${data.page}/${data.pageCount}`,
        method: 'GET'
    })
}

const releaseVideo = (data) => {
    return fetch({
        url: `${shop_url}/shop/shop/good/video`,
        data,
        method: 'post'
    })
}

const delVideo = (goodId) => {
    return fetch({
        url:`${shop_url}/shop/shop/good/video/${goodId}`,
        method:'DELETE'
    })
}

const getRedPacket = (data) =>{
    return fetch({
        url:`${shop_url}/shop/shop/packet/good/list/mp`,
        method:'POST',
        data
    })
}

const setPacketType = (data) => {
    return fetch({
        url:`${shop_url}/shop/shop/packet/good`,
        method:'POST',
        data
    })
}


export {
    upadteGoodStatus,
    getUploadToken,
    tradeGoods,
    getUploadId,
    addGoods,
    addbatch,
    getbatch,
    getgoodsclassification,
    putGoods,
    getgoodInfo,
    exitGoods,
    getGoodCategory,
    upadteGoodStock,
    getUserInfo,
    goodsShelve,
    getGoodsExcel,
    addPreGoods,
    setPreGoods,
    getpreSellList,
    exitPreGoods,
    getSeckillGood,
    setSeckill,
    getSeckillList,
    delSeckill,
    getSeckillDetails,
    editSeckill,
    getDailyExcel,
    getVideoList,
    releaseVideo,
    delVideo,
    getRedPacket,
    setPacketType
}


// WEBPACK FOOTER //
// ./src/api/goods/index.js